export default __webpack_public_path__ + "static/media/u1.6f1a4be9.png";